/* WhatsApp contacts: international digits only, without +, spaces or dashes.
   Main CTAs and enquiry forms use whatsappNumber; alternate links use whatsappBackupNumber. */
window.SHAVERA_CONFIG = {
  whatsappNumber: "8618898644220",
  whatsappBackupNumber: "642108848360",
  brandName: "SHAVERA"
};
